(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports={
    "days": [
        {
            "id": "weekday",
            "label": "Dias Úteis"
        },
        {
            "id": "saturday",
            "label": "Sábados"
        },
        {
            "id": "sunday",
            "label": "Domingos e Feriados"
        }
    ],
    "holidays": [
        {
            "name": "Ano Novo",
            "date": "01/01"
        },
        {
            "name": "Dia da Liberdade",
            "date": "04/25"
        },
        {
            "name": "Dia do Trabalhador",
            "date": "05/01"
        },
        {
            "name": "Dia de Camões, de Portugal e das Comunidades Portuguesas",
            "date": "06/10"
        },
        {
            "name": "Assunção de Nossa Senhora",
            "date": "08/15"
        },
        {
            "name": "Implantação da República",
            "date": "10/05"
        },
        {
            "name": "Dia de Todos os Santos",
            "date": "11/01"
        },
        {
            "name": "Restauração da Independência",
            "date": "12/01"
        },
        {
            "name": "Imaculada Conceição",
            "date": "12/08"
        },
        {
            "name": "Natal",
            "date": "12/25"
        },

        {
            "name": "Sexta-Feira Santa",
            "date": "04/10"
        },
        {
            "name": "Corpo de Deus",
            "date": "06/11"
        }
    ],
    "barreiro": [
        {
            "way": "barreiro-terreiro",
            "departure": "Barreiro",
            "arrival": "Terreiro do Paço",
            "days": [
                {
                    "day": "weekday",
                    "schedule": [
                        {
                            "h": "05",
                            "m": "05"
                        },
                        {
                            "h": "05",
                            "m": "20"
                        },
                        {
                            "h": "05",
                            "m": "55"
                        },
                        {
                            "h": "06",
                            "m": "15"
                        },
                        {
                            "h": "06",
                            "m": "35"
                        },
                        {
                            "h": "06",
                            "m": "45"
                        },
                        {
                            "h": "06",
                            "m": "55"
                        },
                        {
                            "h": "07",
                            "m": "00"
                        },
                        {
                            "h": "07",
                            "m": "10"
                        },
                        {
                            "h": "07",
                            "m": "15"
                        },
                        {
                            "h": "07",
                            "m": "25"
                        },
                        {
                            "h": "07",
                            "m": "35"
                        },
                        {
                            "h": "07",
                            "m": "45"
                        },
                        {
                            "h": "07",
                            "m": "50"
                        },
                        {
                            "h": "08",
                            "m": "00"
                        },
                        {
                            "h": "08",
                            "m": "05"
                        },
                        {
                            "h": "08",
                            "m": "15"
                        },
                        {
                            "h": "08",
                            "m": "25"
                        },
                        {
                            "h": "08",
                            "m": "35"
                        },
                        {
                            "h": "08",
                            "m": "40"
                        },
                        {
                            "h": "08",
                            "m": "50"
                        },
                        {
                            "h": "08",
                            "m": "55"
                        },
                        {
                            "h": "09",
                            "m": "10"
                        },
                        {
                            "h": "09",
                            "m": "25"
                        },
                        {
                            "h": "09",
                            "m": "40"
                        },
                        {
                            "h": "09",
                            "m": "55"
                        },
                        {
                            "h": "10",
                            "m": "25"
                        },
                        {
                            "h": "10",
                            "m": "55"
                        },
                        {
                            "h": "11",
                            "m": "25"
                        },
                        {
                            "h": "11",
                            "m": "55"
                        },
                        {
                            "h": "12",
                            "m": "30"
                        },
                        {
                            "h": "12",
                            "m": "55"
                        },
                        {
                            "h": "13",
                            "m": "25"
                        },
                        {
                            "h": "13",
                            "m": "55"
                        },
                        {
                            "h": "14",
                            "m": "25"
                        },
                        {
                            "h": "14",
                            "m": "55"
                        },
                        {
                            "h": "15",
                            "m": "10"
                        },
                        {
                            "h": "15",
                            "m": "35"
                        },
                        {
                            "h": "16",
                            "m": "00"
                        },
                        {
                            "h": "16",
                            "m": "15"
                        },
                        {
                            "h": "16",
                            "m": "20"
                        },
                        {
                            "h": "16",
                            "m": "30"
                        },
                        {
                            "h": "16",
                            "m": "40"
                        },
                        {
                            "h": "16",
                            "m": "55"
                        },
                        {
                            "h": "17",
                            "m": "05"
                        },
                        {
                            "h": "17",
                            "m": "10"
                        },
                        {
                            "h": "17",
                            "m": "20"
                        },
                        {
                            "h": "17",
                            "m": "30"
                        },
                        {
                            "h": "17",
                            "m": "35"
                        },
                        {
                            "h": "17",
                            "m": "45"
                        },
                        {
                            "h": "17",
                            "m": "55"
                        },
                        {
                            "h": "18",
                            "m": "00"
                        },
                        {
                            "h": "18",
                            "m": "10"
                        },
                        {
                            "h": "18",
                            "m": "20"
                        },
                        {
                            "h": "18",
                            "m": "25"
                        },
                        {
                            "h": "18",
                            "m": "35"
                        },
                        {
                            "h": "18",
                            "m": "45"
                        },
                        {
                            "h": "18",
                            "m": "50"
                        },
                        {
                            "h": "19",
                            "m": "00"
                        },
                        {
                            "h": "19",
                            "m": "10"
                        },
                        {
                            "h": "19",
                            "m": "15"
                        },
                        {
                            "h": "19",
                            "m": "25"
                        },
                        {
                            "h": "19",
                            "m": "35"
                        },
                        {
                            "h": "19",
                            "m": "50"
                        },
                        {
                            "h": "20",
                            "m": "00"
                        },
                        {
                            "h": "20",
                            "m": "10"
                        },
                        {
                            "h": "20",
                            "m": "35"
                        },
                        {
                            "h": "21",
                            "m": "00"
                        },
                        {
                            "h": "21",
                            "m": "25"
                        },
                        {
                            "h": "22",
                            "m": "00"
                        },
                        {
                            "h": "22",
                            "m": "25"
                        },
                        {
                            "h": "23",
                            "m": "00"
                        },
                        {
                            "h": "23",
                            "m": "30"
                        },
                        {
                            "h": "00",
                            "m": "05",
                            "am": true
                        },
                        {
                            "h": "00",
                            "m": "30",
                            "am": true
                        },
                        {
                            "h": "01",
                            "m": "30",
                            "am": true
                        }
                    ]
                },
                {
                    "day": "saturday",
                    "schedule": [
                        {
                            "h": "05",
                            "m": "15"
                        },
                        {
                            "h": "05",
                            "m": "45"
                        },
                        {
                            "h": "06",
                            "m": "22"
                        },
                        {
                            "h": "06",
                            "m": "50"
                        },
                        {
                            "h": "07",
                            "m": "25"
                        },
                        {
                            "h": "07",
                            "m": "55"
                        },
                        {
                            "h": "08",
                            "m": "25"
                        },
                        {
                            "h": "08",
                            "m": "55"
                        },
                        {
                            "h": "09",
                            "m": "25"
                        },
                        {
                            "h": "09",
                            "m": "55"
                        },
                        {
                            "h": "10",
                            "m": "25"
                        },
                        {
                            "h": "11",
                            "m": "25"
                        },
                        {
                            "h": "12",
                            "m": "25"
                        },
                        {
                            "h": "13",
                            "m": "25"
                        },
                        {
                            "h": "14",
                            "m": "25"
                        },
                        {
                            "h": "14",
                            "m": "55"
                        },
                        {
                            "h": "15",
                            "m": "25"
                        },
                        {
                            "h": "15",
                            "m": "55"
                        },
                        {
                            "h": "16",
                            "m": "25"
                        },
                        {
                            "h": "16",
                            "m": "55"
                        },
                        {
                            "h": "17",
                            "m": "25"
                        },
                        {
                            "h": "17",
                            "m": "55"
                        },
                        {
                            "h": "18",
                            "m": "25"
                        },
                        {
                            "h": "18",
                            "m": "55"
                        },
                        {
                            "h": "19",
                            "m": "25"
                        },
                        {
                            "h": "20",
                            "m": "25"
                        },
                        {
                            "h": "20",
                            "m": "55"
                        },
                        {
                            "h": "21",
                            "m": "25"
                        },
                        {
                            "h": "22",
                            "m": "25"
                        },
                        {
                            "h": "23",
                            "m": "30"
                        },
                        {
                            "h": "00",
                            "m": "05",
                            "am": true
                        },
                        {
                            "h": "00",
                            "m": "30",
                            "am": true
                        },
                        {
                            "h": "01",
                            "m": "30",
                            "am": true
                        }
                    ]
                },
                {
                    "day": "sunday",
                    "schedule": [
                        {
                            "h": "05",
                            "m": "15"
                        },
                        {
                            "h": "05",
                            "m": "45"
                        },
                        {
                            "h": "06",
                            "m": "22"
                        },
                        {
                            "h": "06",
                            "m": "50"
                        },
                        {
                            "h": "07",
                            "m": "25"
                        },
                        {
                            "h": "08",
                            "m": "25"
                        },
                        {
                            "h": "09",
                            "m": "25"
                        },
                        {
                            "h": "10",
                            "m": "25"
                        },
                        {
                            "h": "11",
                            "m": "25"
                        },
                        {
                            "h": "12",
                            "m": "25"
                        },
                        {
                            "h": "13",
                            "m": "25"
                        },
                        {
                            "h": "14",
                            "m": "25"
                        },
                        {
                            "h": "14",
                            "m": "55"
                        },
                        {
                            "h": "15",
                            "m": "25"
                        },
                        {
                            "h": "15",
                            "m": "55"
                        },
                        {
                            "h": "16",
                            "m": "25"
                        },
                        {
                            "h": "16",
                            "m": "55"
                        },
                        {
                            "h": "17",
                            "m": "25"
                        },
                        {
                            "h": "17",
                            "m": "55"
                        },
                        {
                            "h": "18",
                            "m": "25"
                        },
                        {
                            "h": "18",
                            "m": "55"
                        },
                        {
                            "h": "19",
                            "m": "25"
                        },
                        {
                            "h": "20",
                            "m": "25"
                        },
                        {
                            "h": "20",
                            "m": "55"
                        },
                        {
                            "h": "21",
                            "m": "25"
                        },
                        {
                            "h": "22",
                            "m": "25"
                        },
                        {
                            "h": "23",
                            "m": "30"
                        },
                        {
                            "h": "00",
                            "m": "05",
                            "am": true
                        },
                        {
                            "h": "00",
                            "m": "30",
                            "am": true
                        },
                        {
                            "h": "01",
                            "m": "30",
                            "am": true
                        }
                    ]
                }
            ]
        },
        {
            "way": "terreiro-barreiro",
            "departure": "Terreiro do Paço",
            "arrival": "Barreiro",
            "days": [
                {
                    "day": "weekday",
                    "schedule": [
                        {
                            "h": "05",
                            "m": "30"
                        },
                        {
                            "h": "05",
                            "m": "50"
                        },
                        {
                            "h": "06",
                            "m": "20"
                        },
                        {
                            "h": "06",
                            "m": "40"
                        },
                        {
                            "h": "07",
                            "m": "00"
                        },
                        {
                            "h": "07",
                            "m": "10"
                        },
                        {
                            "h": "07",
                            "m": "20"
                        },
                        {
                            "h": "07",
                            "m": "25"
                        },
                        {
                            "h": "07",
                            "m": "35"
                        },
                        {
                            "h": "07",
                            "m": "40"
                        },
                        {
                            "h": "07",
                            "m": "50"
                        },
                        {
                            "h": "08",
                            "m": "00"
                        },
                        {
                            "h": "08",
                            "m": "10"
                        },
                        {
                            "h": "08",
                            "m": "15"
                        },
                        {
                            "h": "08",
                            "m": "25"
                        },
                        {
                            "h": "08",
                            "m": "30"
                        },
                        {
                            "h": "08",
                            "m": "40"
                        },
                        {
                            "h": "08",
                            "m": "50"
                        },
                        {
                            "h": "09",
                            "m": "00"
                        },
                        {
                            "h": "09",
                            "m": "05"
                        },
                        {
                            "h": "09",
                            "m": "15"
                        },
                        {
                            "h": "09",
                            "m": "20"
                        },
                        {
                            "h": "09",
                            "m": "40"
                        },
                        {
                            "h": "09",
                            "m": "55"
                        },
                        {
                            "h": "10",
                            "m": "25"
                        },
                        {
                            "h": "10",
                            "m": "55"
                        },
                        {
                            "h": "11",
                            "m": "25"
                        },
                        {
                            "h": "11",
                            "m": "55"
                        },
                        {
                            "h": "12",
                            "m": "25"
                        },
                        {
                            "h": "13",
                            "m": "00"
                        },
                        {
                            "h": "13",
                            "m": "25"
                        },
                        {
                            "h": "13",
                            "m": "55"
                        },
                        {
                            "h": "14",
                            "m": "25"
                        },
                        {
                            "h": "14",
                            "m": "55"
                        },
                        {
                            "h": "15",
                            "m": "20"
                        },
                        {
                            "h": "15",
                            "m": "35"
                        },
                        {
                            "h": "16",
                            "m": "00"
                        },
                        {
                            "h": "16",
                            "m": "25"
                        },
                        {
                            "h": "16",
                            "m": "40"
                        },
                        {
                            "h": "16",
                            "m": "45"
                        },
                        {
                            "h": "16",
                            "m": "55"
                        },
                        {
                            "h": "17",
                            "m": "05"
                        },
                        {
                            "h": "17",
                            "m": "20"
                        },
                        {
                            "h": "17",
                            "m": "30"
                        },
                        {
                            "h": "17",
                            "m": "35"
                        },
                        {
                            "h": "17",
                            "m": "45"
                        },
                        {
                            "h": "17",
                            "m": "55"
                        },
                        {
                            "h": "18",
                            "m": "00"
                        },
                        {
                            "h": "18",
                            "m": "10"
                        },
                        {
                            "h": "18",
                            "m": "20"
                        },
                        {
                            "h": "18",
                            "m": "25"
                        },
                        {
                            "h": "18",
                            "m": "35"
                        },
                        {
                            "h": "18",
                            "m": "45"
                        },
                        {
                            "h": "18",
                            "m": "50"
                        },
                        {
                            "h": "19",
                            "m": "00"
                        },
                        {
                            "h": "19",
                            "m": "10"
                        },
                        {
                            "h": "19",
                            "m": "15"
                        },
                        {
                            "h": "19",
                            "m": "25"
                        },
                        {
                            "h": "19",
                            "m": "35"
                        },
                        {
                            "h": "19",
                            "m": "40"
                        },
                        {
                            "h": "19",
                            "m": "50"
                        },
                        {
                            "h": "20",
                            "m": "00"
                        },
                        {
                            "h": "20",
                            "m": "15"
                        },
                        {
                            "h": "20",
                            "m": "25"
                        },
                        {
                            "h": "20",
                            "m": "35"
                        },
                        {
                            "h": "21",
                            "m": "00"
                        },
                        {
                            "h": "21",
                            "m": "25"
                        },
                        {
                            "h": "21",
                            "m": "55"
                        },
                        {
                            "h": "22",
                            "m": "30"
                        },
                        {
                            "h": "22",
                            "m": "55"
                        },
                        {
                            "h": "23",
                            "m": "30"
                        },
                        {
                            "h": "00",
                            "m": "00",
                            "am": true
                        },
                        {
                            "h": "00",
                            "m": "30",
                            "am": true
                        },
                        {
                            "h": "01",
                            "m": "00",
                            "am": true
                        },
                        {
                            "h": "02",
                            "m": "00",
                            "am": true
                        }
                    ]
                },
                {
                    "day": "saturday",
                    "schedule": [
                        {
                            "h": "05",
                            "m": "45"
                        },
                        {
                            "h": "06",
                            "m": "15"
                        },
                        {
                            "h": "06",
                            "m": "47"
                        },
                        {
                            "h": "07",
                            "m": "15"
                        },
                        {
                            "h": "07",
                            "m": "55"
                        },
                        {
                            "h": "08",
                            "m": "25"
                        },
                        {
                            "h": "08",
                            "m": "55"
                        },
                        {
                            "h": "09",
                            "m": "25"
                        },
                        {
                            "h": "09",
                            "m": "55"
                        },
                        {
                            "h": "10",
                            "m": "25"
                        },
                        {
                            "h": "10",
                            "m": "55"
                        },
                        {
                            "h": "11",
                            "m": "55"
                        },
                        {
                            "h": "12",
                            "m": "55"
                        },
                        {
                            "h": "13",
                            "m": "55"
                        },
                        {
                            "h": "14",
                            "m": "55"
                        },
                        {
                            "h": "15",
                            "m": "25"
                        },
                        {
                            "h": "15",
                            "m": "55"
                        },
                        {
                            "h": "16",
                            "m": "25"
                        },
                        {
                            "h": "16",
                            "m": "55"
                        },
                        {
                            "h": "17",
                            "m": "25"
                        },
                        {
                            "h": "17",
                            "m": "55"
                        },
                        {
                            "h": "18",
                            "m": "25"
                        },
                        {
                            "h": "18",
                            "m": "55"
                        },
                        {
                            "h": "19",
                            "m": "25"
                        },
                        {
                            "h": "19",
                            "m": "55"
                        },
                        {
                            "h": "20",
                            "m": "55"
                        },
                        {
                            "h": "21",
                            "m": "25"
                        },
                        {
                            "h": "21",
                            "m": "55"
                        },
                        {
                            "h": "22",
                            "m": "55"
                        },
                        {
                            "h": "00",
                            "m": "00",
                            "am": true
                        },
                        {
                            "h": "00",
                            "m": "30",
                            "am": true
                        },
                        {
                            "h": "01",
                            "m": "00",
                            "am": true
                        },
                        {
                            "h": "02",
                            "m": "00",
                            "am": true
                        }
                    ]
                },
                {
                    "day": "sunday",
                    "schedule": [
                        {
                            "h": "05",
                            "m": "45"
                        },
                        {
                            "h": "06",
                            "m": "15"
                        },
                        {
                            "h": "06",
                            "m": "47"
                        },
                        {
                            "h": "07",
                            "m": "15"
                        },
                        {
                            "h": "07",
                            "m": "55"
                        },
                        {
                            "h": "08",
                            "m": "55"
                        },
                        {
                            "h": "09",
                            "m": "55"
                        },
                        {
                            "h": "10",
                            "m": "55"
                        },
                        {
                            "h": "11",
                            "m": "55"
                        },
                        {
                            "h": "12",
                            "m": "55"
                        },
                        {
                            "h": "13",
                            "m": "55"
                        },
                        {
                            "h": "14",
                            "m": "55"
                        },
                        {
                            "h": "15",
                            "m": "25"
                        },
                        {
                            "h": "15",
                            "m": "55"
                        },
                        {
                            "h": "16",
                            "m": "25"
                        },
                        {
                            "h": "16",
                            "m": "55"
                        },
                        {
                            "h": "17",
                            "m": "25"
                        },
                        {
                            "h": "17",
                            "m": "55"
                        },
                        {
                            "h": "18",
                            "m": "25"
                        },
                        {
                            "h": "18",
                            "m": "55"
                        },
                        {
                            "h": "19",
                            "m": "25"
                        },
                        {
                            "h": "19",
                            "m": "55"
                        },
                        {
                            "h": "20",
                            "m": "55"
                        },
                        {
                            "h": "21",
                            "m": "25"
                        },
                        {
                            "h": "21",
                            "m": "55"
                        },
                        {
                            "h": "22",
                            "m": "55"
                        },
                        {
                            "h": "00",
                            "m": "00",
                            "am": true
                        },
                        {
                            "h": "00",
                            "m": "30",
                            "am": true
                        },
                        {
                            "h": "01",
                            "m": "00",
                            "am": true
                        },
                        {
                            "h": "02",
                            "m": "00",
                            "am": true
                        }
                    ]
                }
            ]
        }
    ],
    "seixal": [
        {
            "way": "seixal-caissodre",
            "departure": "Seixal",
            "arrival": "Cais do Sodré",
            "days": [
                {
                    "day": "weekday",
                    "schedule": [
                        {
                            "h": "06",
                            "m": "10"
                        },
                        {
                            "h": "06",
                            "m": "40"
                        },
                        {
                            "h": "07",
                            "m": "00"
                        },
                        {
                            "h": "07",
                            "m": "25"
                        },
                        {
                            "h": "07",
                            "m": "45"
                        },
                        {
                            "h": "08",
                            "m": "10"
                        },
                        {
                            "h": "08",
                            "m": "30"
                        },
                        {
                            "h": "08",
                            "m": "55"
                        },
                        {
                            "h": "09",
                            "m": "15"
                        },
                        {
                            "h": "09",
                            "m": "40"
                        },
                        {
                            "h": "10",
                            "m": "05"
                        },
                        {
                            "h": "11",
                            "m": "00"
                        },
                        {
                            "h": "12",
                            "m": "30"
                        },
                        {
                            "h": "14",
                            "m": "00"
                        },
                        {
                            "h": "15",
                            "m": "30"
                        },
                        {
                            "h": "16",
                            "m": "20"
                        },
                        {
                            "h": "16",
                            "m": "45"
                        },
                        {
                            "h": "17",
                            "m": "05"
                        },
                        {
                            "h": "17",
                            "m": "30"
                        },
                        {
                            "h": "17",
                            "m": "50"
                        },
                        {
                            "h": "18",
                            "m": "15"
                        },
                        {
                            "h": "18",
                            "m": "40"
                        },
                        {
                            "h": "19",
                            "m": "05"
                        },
                        {
                            "h": "19",
                            "m": "30"
                        },
                        {
                            "h": "20",
                            "m": "30"
                        },
                        {
                            "h": "21",
                            "m": "30"
                        },
                        {
                            "h": "22",
                            "m": "30"
                        }
                    ]
                },
                {
                    "day": "saturday",
                    "schedule": [
                        {
                            "h": "07",
                            "m": "00"
                        },
                        {
                            "h": "08",
                            "m": "00"
                        },
                        {
                            "h": "09",
                            "m": "00"
                        },
                        {
                            "h": "11",
                            "m": "00"
                        },
                        {
                            "h": "13",
                            "m": "00"
                        },
                        {
                            "h": "15",
                            "m": "00"
                        },
                        {
                            "h": "16",
                            "m": "30"
                        },
                        {
                            "h": "18",
                            "m": "00"
                        },
                        {
                            "h": "19",
                            "m": "30"
                        },
                        {
                            "h": "20",
                            "m": "30"
                        },
                        {
                            "h": "21",
                            "m": "30"
                        }
                    ]
                },
                {
                    "day": "sunday",
                    "schedule": [
                        {
                            "h": "08",
                            "m": "00"
                        },
                        {
                            "h": "09",
                            "m": "00"
                        },
                        {
                            "h": "11",
                            "m": "00"
                        },
                        {
                            "h": "13",
                            "m": "00"
                        },
                        {
                            "h": "15",
                            "m": "00"
                        },
                        {
                            "h": "16",
                            "m": "30"
                        },
                        {
                            "h": "18",
                            "m": "00"
                        },
                        {
                            "h": "19",
                            "m": "30"
                        },
                        {
                            "h": "21",
                            "m": "00"
                        }
                    ]
                }
            ]
        },
        {
            "way": "caissodre-seixal",
            "departure": "Cais do Sodré",
            "arrival": "Seixal",
            "days": [
                {
                    "day": "weekday",
                    "schedule": [
                        {
                            "h": "06",
                            "m": "35"
                        },
                        {
                            "h": "07",
                            "m": "05"
                        },
                        {
                            "h": "07",
                            "m": "25"
                        },
                        {
                            "h": "07",
                            "m": "50"
                        },
                        {
                            "h": "08",
                            "m": "10"
                        },
                        {
                            "h": "08",
                            "m": "35"
                        },
                        {
                            "h": "08",
                            "m": "55"
                        },
                        {
                            "h": "09",
                            "m": "20"
                        },
                        {
                            "h": "09",
                            "m": "40"
                        },
                        {
                            "h": "10",
                            "m": "05"
                        },
                        {
                            "h": "11",
                            "m": "30"
                        },
                        {
                            "h": "13",
                            "m": "00"
                        },
                        {
                            "h": "14",
                            "m": "30"
                        },
                        {
                            "h": "15",
                            "m": "55"
                        },
                        {
                            "h": "16",
                            "m": "45"
                        },
                        {
                            "h": "17",
                            "m": "10"
                        },
                        {
                            "h": "17",
                            "m": "30"
                        },
                        {
                            "h": "17",
                            "m": "55"
                        },
                        {
                            "h": "18",
                            "m": "15"
                        },
                        {
                            "h": "18",
                            "m": "40"
                        },
                        {
                            "h": "19",
                            "m": "05"
                        },
                        {
                            "h": "19",
                            "m": "30"
                        },
                        {
                            "h": "20",
                            "m": "00"
                        },
                        {
                            "h": "21",
                            "m": "00"
                        },
                        {
                            "h": "22",
                            "m": "00"
                        },
                        {
                            "h": "23",
                            "m": "15"
                        }
                    ]
                },
                {
                    "day": "saturday",
                    "schedule": [
                        {
                            "h": "07",
                            "m": "30"
                        },
                        {
                            "h": "08",
                            "m": "30"
                        },
                        {
                            "h": "09",
                            "m": "30"
                        },
                        {
                            "h": "11",
                            "m": "30"
                        },
                        {
                            "h": "13",
                            "m": "30"
                        },
                        {
                            "h": "15",
                            "m": "30"
                        },
                        {
                            "h": "17",
                            "m": "00"
                        },
                        {
                            "h": "18",
                            "m": "30"
                        },
                        {
                            "h": "20",
                            "m": "00"
                        },
                        {
                            "h": "21",
                            "m": "00"
                        },
                        {
                            "h": "22",
                            "m": "00"
                        }
                    ]
                },
                {
                    "day": "sunday",
                    "schedule": [
                        {
                            "h": "08",
                            "m": "30"
                        },
                        {
                            "h": "09",
                            "m": "30"
                        },
                        {
                            "h": "11",
                            "m": "30"
                        },
                        {
                            "h": "13",
                            "m": "30"
                        },
                        {
                            "h": "15",
                            "m": "30"
                        },
                        {
                            "h": "17",
                            "m": "00"
                        },
                        {
                            "h": "18",
                            "m": "30"
                        },
                        {
                            "h": "20",
                            "m": "00"
                        },
                        {
                            "h": "21",
                            "m": "30"
                        }
                    ]
                }
            ]
        }
    ],
    "montijo": [
        {
            "way": "montijo-caissodre",
            "departure": "Montijo",
            "arrival": "Cais do Sodré",
            "days": [
                {
                    "day": "weekday",
                    "schedule": [
                        {
                            "h": "06",
                            "m": "00"
                        },
                        {
                            "h": "07",
                            "m": "00"
                        },
                        {
                            "h": "07",
                            "m": "30"
                        },
                        {
                            "h": "08",
                            "m": "30"
                        },
                        {
                            "h": "09",
                            "m": "00"
                        },
                        {
                            "h": "10",
                            "m": "30"
                        },
                        {
                            "h": "12",
                            "m": "00"
                        },
                        {
                            "h": "13",
                            "m": "30"
                        },
                        {
                            "h": "15",
                            "m": "00"
                        },
                        {
                            "h": "16",
                            "m": "00"
                        },
                        {
                            "h": "16",
                            "m": "30"
                        },
                        {
                            "h": "17",
                            "m": "00"
                        },
                        {
                            "h": "17",
                            "m": "30"
                        },
                        {
                            "h": "18",
                            "m": "00"
                        },
                        {
                            "h": "18",
                            "m": "30"
                        },
                        {
                            "h": "19",
                            "m": "00"
                        },
                        {
                            "h": "19",
                            "m": "30"
                        },
                        {
                            "h": "20",
                            "m": "30"
                        },
                        {
                            "h": "21",
                            "m": "30"
                        },
                        {
                            "h": "22",
                            "m": "30"
                        }
                    ]
                },
                {
                    "day": "saturday",
                    "schedule": [
                        {
                            "h": "06",
                            "m": "30"
                        },
                        {
                            "h": "07",
                            "m": "30"
                        },
                        {
                            "h": "08",
                            "m": "30"
                        },
                        {
                            "h": "10",
                            "m": "30"
                        },
                        {
                            "h": "12",
                            "m": "30"
                        },
                        {
                            "h": "14",
                            "m": "30"
                        },
                        {
                            "h": "16",
                            "m": "00"
                        },
                        {
                            "h": "17",
                            "m": "30"
                        },
                        {
                            "h": "19",
                            "m": "00"
                        },
                        {
                            "h": "20",
                            "m": "00"
                        },
                        {
                            "h": "21",
                            "m": "10"
                        }
                    ]
                },
                {
                    "day": "sunday",
                    "schedule": [

                        {
                            "h": "08",
                            "m": "10"
                        },
                        {
                            "h": "10",
                            "m": "10"
                        },
                        {
                            "h": "12",
                            "m": "30"
                        },
                        {
                            "h": "14",
                            "m": "30"
                        },
                        {
                            "h": "16",
                            "m": "00"
                        },
                        {
                            "h": "17",
                            "m": "30"
                        },
                        {
                            "h": "19",
                            "m": "00"
                        },
                        {
                            "h": "20",
                            "m": "45"
                        }
                    ]
                }
            ]
        },
        {
            "way": "caissodre-montijo",
            "departure": "Cais do Sodré",
            "arrival": "Montijo",
            "days": [
                {
                    "day": "weekday",
                    "schedule": [
                        {
                            "h": "06",
                            "m": "30"
                        },
                        {
                            "h": "07",
                            "m": "30"
                        },
                        {
                            "h": "08",
                            "m": "00"
                        },
                        {
                            "h": "08",
                            "m": "30"
                        },
                        {
                            "h": "09",
                            "m": "00"
                        },
                        {
                            "h": "10",
                            "m": "00"
                        },
                        {
                            "h": "11",
                            "m": "00"
                        },
                        {
                            "h": "12",
                            "m": "30"
                        },
                        {
                            "h": "14",
                            "m": "00"
                        },
                        {
                            "h": "15",
                            "m": "30"
                        },
                        {
                            "h": "16",
                            "m": "30"
                        },
                        {
                            "h": "17",
                            "m": "00"
                        },
                        {
                            "h": "17",
                            "m": "30"
                        },
                        {
                            "h": "18",
                            "m": "00"
                        },
                        {
                            "h": "18",
                            "m": "30"
                        },
                        {
                            "h": "19",
                            "m": "00"
                        },
                        {
                            "h": "19",
                            "m": "30"
                        },
                        {
                            "h": "20",
                            "m": "00"
                        },
                        {
                            "h": "21",
                            "m": "00"
                        },
                        {
                            "h": "22",
                            "m": "00"
                        },
                        {
                            "h": "23",
                            "m": "15"
                        }
                    ]
                },
                {
                    "day": "saturday",
                    "schedule": [
                        {
                            "h": "07",
                            "m": "00"
                        },
                        {
                            "h": "08",
                            "m": "00"
                        },
                        {
                            "h": "09",
                            "m": "00"
                        },
                        {
                            "h": "11",
                            "m": "00"
                        },
                        {
                            "h": "13",
                            "m": "00"
                        },
                        {
                            "h": "15",
                            "m": "00"
                        },
                        {
                            "h": "16",
                            "m": "30"
                        },
                        {
                            "h": "18",
                            "m": "00"
                        },
                        {
                            "h": "19",
                            "m": "30"
                        },
                        {
                            "h": "20",
                            "m": "30"
                        },
                        {
                            "h": "22",
                            "m": "00"
                        }
                    ]
                },
                {
                    "day": "sunday",
                    "schedule": [
                        {
                            "h": "08",
                            "m": "40"
                        },
                        {
                            "h": "10",
                            "m": "40"
                        },
                        {
                            "h": "13",
                            "m": "00"
                        },
                        {
                            "h": "15",
                            "m": "00"
                        },
                        {
                            "h": "16",
                            "m": "30"
                        },
                        {
                            "h": "18",
                            "m": "00"
                        },
                        {
                            "h": "19",
                            "m": "30"
                        },
                        {
                            "h": "21",
                            "m": "30"
                        }
                    ]
                }
            ]
        }

    ]
}
},{}],2:[function(require,module,exports){
"use strict";

var _data = _interopRequireDefault(require("../data/data.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var App = {
  Data: _data["default"],
  Now: new Date(),
  //Now: new Date(2019, 5-1, 4, 23, 0),
  //Now: new Date(2019, 5-1, 5, 0, 1),
  //Now: new Date(2019, 5-1, 5, 3, 0),
  //Now: new Date(2019, 5-1, 1, 22, 0), //holiday
  Holidays: [],
  PageId: null,
  CurrentDayOfWeek: '',
  Current: {
    Hub: null,
    Way: null,
    Schedule: null,
    DayOfWeek: '',
    IsYesterday: null,
    IsToday: null,
    IsTomorrow: null
  },
  SelectedDayOfWeek: null,
  // selected tab
  DOM: {
    Pages: {
      Home: document.getElementById('homePage'),
      Schedule: document.getElementById('schedulePage')
    },
    Itineraries: document.querySelectorAll('.js-next-time'),
    ItinerariesIcons: document.querySelectorAll('.js-next-time-icon'),
    Title: document.querySelector('.js-title'),
    Schedules: document.querySelectorAll('.js-schedule'),
    Tabs: document.querySelectorAll('.js-tab'),
    TabPanels: document.querySelectorAll('.js-tabpanel'),
    Waiting: document.querySelectorAll('.is-waiting')
  },
  init: function init() {
    var _this = this;

    // Settings
    this.PageId = document.body.dataset.pageId;
    this.Current.Hub = this.Data[this.PageId];

    if (this.Current.Hub) {
      // check if is a scheduler page
      this.goToDefaultPage(); // get data

      this.getHolidays();
      this.Current.Hub.forEach(function (way, index) {
        _this.getDayOfWeek(way);

        _this.getNextTime(index);
      });
      this.createNavigation();
    }

    this.setNavigationEvents(); // show hidden elements

    this.DOM.Waiting.forEach(function (el) {
      el.classList.remove('is-waiting');
    });
    this.highlightNav();
  },
  // GET/SET
  getHolidays: function getHolidays() {
    var _this2 = this;

    var year = this.Now.getFullYear();
    this.Data.holidays.forEach(function (holiday) {
      holiday.date = new Date(year + '/' + holiday.date);

      _this2.Holidays.push(holiday);
    });
    /*
    var vm = this;
    var Http = new XMLHttpRequest();
    var url = `http://services.sapo.pt/Holiday/GetNationalHolidays?year=${this.Now.getFullYear()}`;
    Http.open('GET', url);
    Http.send();
    Http.onreadystatechange = (e) => {
        if (Http.responseText) {
            vm.Holidays = new DOMParser().parseFromString(Http.responseText, "text/xml");
            //console.log(vm.Holidays.getElementsByTagName("Holiday")[0].querySelector("Date")/* .nodeValue *);
        }
    } */
  },
  getDayOfWeek: function getDayOfWeek(way) {
    /* Objective: get the following times, to make the if's:
         - yesterday's last time
         - today's first time
         - today's last time
    */
    // Get weekdays ===========================
    // get yesterday's weekday
    var yesterday = new Date(this.Now);
    yesterday.setDate(yesterday.getDate() - 1);
    var yesterdayWeekday = this.getWeekday(yesterday); // get today's weekday

    var weekday = this.getWeekday(this.Now); // get tomorrow's weekday

    var tomorrow = new Date(this.Now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    var tomorrowWeekday = this.getWeekday(tomorrow); // Get schedules ===========================
    // get yesterday's schedule

    var yesterdaySchedule = way.days.find(function (x) {
      return x.day == yesterdayWeekday;
    }).schedule; // get today's schedule

    var schedule = way.days.find(function (x) {
      return x.day == weekday;
    }).schedule; // Get dateTimes ===========================
    // get yesterday's last dateTime

    var yesterdayLastArrayTime = yesterdaySchedule[yesterdaySchedule.length - 1];
    var yesterdayLastTime = yesterdayLastArrayTime.am ? new Date(this.Now) : new Date(yesterday); // check if yesterday's last time is after midnight and set day according that (yesterday or today) - (am === after midnight)

    yesterdayLastTime.setHours(yesterdayLastArrayTime.h, yesterdayLastArrayTime.m, 0); // get today's first dateTime

    var firstArrayTime = schedule[0];
    var firstTime = new Date(this.Now);
    firstTime.setHours(firstArrayTime.h, firstArrayTime.m, 0); // get today's last dateTime

    var lastArrayTime = schedule[schedule.length - 1];
    var lastTime = lastArrayTime.am ? new Date(tomorrow) : new Date(this.Now); // check if today's last time is after midnight and set day according that (today or tomorrow) - (am === after midnight)

    lastTime.setHours(lastArrayTime.h, lastArrayTime.m, 0); // check if now is in yesterday's schedule

    var now = this.Now.getTime();

    if (now > yesterdayLastTime.getTime() && now < lastTime.getTime()) {
      // set weekday and schedule as today
      this.Current.DayOfWeek = weekday;
      this.Current.Schedule = schedule;
      this.SelectedDayOfWeek = weekday;
      this.Current.IsToday = true;
    } else {
      if (now < firstTime.getTime()) {
        // set weekday and schedule as yesterday
        this.Current.DayOfWeek = yesterdayWeekday;
        this.Current.Schedule = yesterdaySchedule;
        this.SelectedDayOfWeek = yesterdayWeekday;
        this.Current.IsYesterday = true;
      } else {
        // case: when last time is before midnight and now it's after that
        // get tomorrow's schedule
        var tomorrowSchedule = way.days.find(function (x) {
          return x.day == tomorrowWeekday;
        }).schedule; // set weekday and schedule as tomorrow

        this.Current.DayOfWeek = tomorrowWeekday;
        this.Current.Schedule = tomorrowSchedule;
        this.SelectedDayOfWeek = tomorrowWeekday;
        this.Current.IsTomorrow = true;
      }
    }
  },
  getNextTime: function getNextTime(index) {
    var _this3 = this;

    console.log(this.Current.DayOfWeek);
    this.Current.Schedule.find(function (time) {
      // build dateTime based on time
      var dateTime = new Date(_this3.Now);
      dateTime.setHours(time.h, time.m, 0); // time of schedule
      // Day fix ================

      if (_this3.Current.IsYesterday && !time.am) // next time is before midnight
        dateTime.setDate(dateTime.getDate() - 1); // set as yesterday

      if (_this3.Current.IsTomorrow) // next time is tomorrow
        dateTime.setDate(dateTime.getDate() + 1); // set as tomorrow

      if (_this3.Current.IsToday && time.am) // schedule is from today, but next time is after midnight
        dateTime.setDate(dateTime.getDate() + 1); // set as tomorrow
      // check if it's next

      if (dateTime.getTime() > _this3.Now.getTime()) {
        // GOT THE NEXT TIME
        // Set next time
        _this3.DOM.Itineraries[index].textContent = dateTime.toLocaleTimeString('PT-pt', {
          hour: 'numeric',
          minute: "2-digit"
        }); // Populate itineraries

        _this3.DOM.ItinerariesIcons[index].classList.remove('is-loading');

        return time.isNext = true;
      }

      ;
    });
  },
  getWeekday: function getWeekday(date) {
    // get weekday
    var weekday = date.getDay(); // check if it is an holiday

    var date = new Date(date);
    date.setHours(0, 0, 0, 0); // set midnight

    var isHoliday = this.Holidays.findIndex(function (holiday) {
      return date.getTime() === holiday.date.getTime();
    }) > -1;
    var dayOfWeek;

    if (isHoliday || weekday == 0) {
      // check if it is an holiday or sunday (must be first)
      dayOfWeek = 'sunday';
    } else if (weekday >= 1 && weekday <= 5) {
      dayOfWeek = 'weekday';
    } else if (weekday == 6) {
      dayOfWeek = 'saturday';
    }

    return dayOfWeek;
  },
  // EVENTS
  setNavigationEvents: function setNavigationEvents() {
    var _this4 = this;

    document.addEventListener('click', function (event) {
      var nav = document.querySelector('.js-nav');
      var clickedElement = event.currentTarget.activeElement;

      if (clickedElement.matches('.js-goto-schedule')) {
        var way = clickedElement.dataset.way;

        _this4.goToSchedulePage(way);
      } else if (clickedElement.matches('.js-goto-home')) {
        _this4.goToHomePage();
      } else if (clickedElement.matches('.js-tab')) {
        _this4.SelectedDayOfWeek = clickedElement.dataset.dayofweek;

        _this4.selectTab();
      } else if (clickedElement.matches('.js-toggle-nav')) {
        nav.classList.toggle('is-open');
      } else if (event.target.matches('.js-nav-link')) {
        _this4.goToHub(event.target);
      } // check if clicked elements are not nav


      if (event.target !== nav && !nav.contains(event.target) && !clickedElement.matches('.js-toggle-nav')) {
        nav.classList.remove('is-open');
      }
    }, false);
  },
  createNavigation: function createNavigation() {
    // on back button
    var app = this;
    window.location.hash = '#inicio'; // set default hash

    window.addEventListener('hashchange', function (e) {
      if (window.location.hash === '#inicio') {
        app.goToHomePage();
      } else if (window.location.hash === '#horario') {
        app.showSchedulePage();
      }
    });
  },
  // DOM MANIPULATION
  goToSchedulePage: function goToSchedulePage(way) {
    var wayIndex = this.Current.Hub.findIndex(function (x) {
      return x.way === way;
    });
    this.Current.Way = this.Current.Hub[wayIndex];
    this.getDayOfWeek(this.Current.Way);
    this.getNextTime(wayIndex);
    this.renderTitle();
    this.renderSchedule();
    this.selectTab();
    this.showSchedulePage();
    this.scrollToCurrentTime();
    window.location.hash = 'horario';
  },
  showSchedulePage: function showSchedulePage() {
    // close Home page tab
    this.DOM.Pages.Home.setAttribute("aria-hidden", true); // open Schedule page

    this.DOM.Pages.Schedule.classList.add("is-active");
    this.DOM.Pages.Schedule.setAttribute("aria-hidden", false);
  },
  goToHomePage: function goToHomePage() {
    this.DOM.Pages.Home.setAttribute("aria-hidden", false);
    this.DOM.Pages.Schedule.classList.remove("is-active");
    this.DOM.Pages.Schedule.setAttribute("aria-hidden", true); // reset tab selection

    this.SelectedDayOfWeek = this.Current.DayOfWeek;
    window.location.hash = 'inicio';
  },
  selectTab: function selectTab() {
    // hide tabs
    this.DOM.Tabs.forEach(function (tab) {
      tab.setAttribute("aria-selected", false);
    });
    this.DOM.TabPanels.forEach(function (panel) {
      panel.setAttribute("aria-hidden", true);
    }); // show tab

    var attr = "[data-dayofweek=\"".concat(this.SelectedDayOfWeek, "\"]");
    document.querySelector(".js-tab".concat(attr)).setAttribute("aria-selected", true);
    document.querySelector(".js-tabpanel".concat(attr)).setAttribute("aria-hidden", false);
  },
  scrollToCurrentTime: function scrollToCurrentTime() {
    // scroll to current time schedule
    setTimeout(function () {
      document.querySelector(".is-next").scrollIntoView({
        block: "center"
      });
    }, 400);
  },
  // RENDER
  renderTitle: function renderTitle() {
    this.DOM.Title.textContent = "".concat(this.Current.Way.departure, " - ").concat(this.Current.Way.arrival);
  },
  renderSchedule: function renderSchedule() {
    var _this5 = this;

    this.DOM.Schedules.forEach(function (schedule, i) {
      var html = '';

      _this5.Current.Way.days[i].schedule.forEach(function (time, j) {
        html += "\n                    <li ".concat(time.isNext ? 'class="is-next"' : '', ">\n                        <span>").concat(time.h, ":").concat(time.m, "</span>\n                    </li>\n                ");
      });

      _this5.DOM.Schedules[i].innerHTML = html;
    });
  },
  // NAVIGATION
  goToDefaultPage: function goToDefaultPage() {
    var hub = localStorage.getItem('hub'); // get default page

    if (hub && hub !== this.PageId) {
      // check if current page is not the default page
      var url = hub ? "".concat(hub, ".html") : '';
      window.location = './' + url;
    }
  },
  goToHub: function goToHub(btn) {
    var hub = btn.dataset.target; // save default page to localstorage

    localStorage.setItem('hub', hub); // go to page

    var url = hub ? "".concat(hub, ".html") : '';
    window.location = './' + url;
  },
  highlightNav: function highlightNav() {
    var pageId = document.body.dataset.pageId;
    var navLink = document.querySelector('.js-nav-link[data-target="' + pageId + '"]');

    if (navLink) {
      navLink.classList.add('is-active');
    } else {
      document.querySelector('.js-nav-link').classList.add('is-active');
    }
  }
};
App.init();
window.App = App;

},{"../data/data.json":1}]},{},[2]);
